module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UnitClaim", "Subscription details") ))==null?'':__t)+
'</legend><p>'+
((__t=(i18n.tc("UnitClaim", "Would you like to create a subscription on %s with these options?").format(alias) ))==null?'':__t)+
'</p><dl> ';
 if ( customer ) { 
__p+=' <dt>'+
((__t=( i18n.tc("UnitClaim", "Billing account:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( customer ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( subscriptionName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("UnitClaim", "Subscription:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( subscriptionName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( ( ! isPrepaid && packagePrice ) || ( context === "forward" && packagePrice ) ) { 
__p+=' <dt>'+
((__t=( i18n.tc("UnitClaim", "Total price:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( packagePrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("UnitClaim", "(tax incl.)") ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></fieldset><fieldset class="button-wrap"><button data-click="overview-cancel">'+
((__t=( i18n.tc("UnitClaim", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="overview-submit">'+
((__t=( i18n.tc("UnitClaim", "Next") ))==null?'':__t)+
'</button></fieldset><div data-region="create-usage"></div>';
}
return __p;
};
